<template>
	<section class="timeline">
		<h2 class="timeline__title">Знаете ли, че?</h2>
		<div class="timeline__item" v-for="article in articles">
			<div class="timeline__item-image">
				<img :src="article.image" alt="Timeline" />
			</div>
			<div class="timeline__item-title" v-html="article.title"></div>
			<div class="timeline__item-description" v-html="article.description"></div>
		</div>
	</section>
</template>

<script>
    export default {
        name: 'articles',
        props: ['articles']
    }
</script>


// WEBPACK FOOTER //
// src/components/articles.vue?37ec53c6